import { Button, styled } from '@mui/material'
import { Flex, FlexBetween, FlexColumn, themeValue } from 'styles'
import { ReactComponent as SvgClose } from './assets/close.svg'

export const Mask = styled('div')<{ height?: number }>`
  z-index: 120;
  position: absolute;
  width: 100%;
  inset: 0;
  top: 0px;
  height: 100%;
  overflow: hidden !important;
  height: ${({ height }) => (height ? height + 'px' : '100%')};
  background-color: ${() =>
    themeValue('rgba(0, 0, 0, 0.7)', 'rgba(5, 7, 20, 0.6)')};
  mix-blend-mode: hard-light;
`

export const HelpMask = styled('div')`
  border-radius: 4px;
  position: absolute;
  background-color: gray;
  opacity: 1;
  pointer-events: auto;
  top: 182px;
  transition: opacity 0.2s ease 0s;
  width: 115px;
}
`
export const Arrow = styled('div')`
  position: absolute;

  &.top {
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid;
    border-bottom-color: #2e363b;
    /* border-bottom-color: ${() =>
      themeValue('rgba(75, 82, 90, 1)', 'rgba(227, 229, 235, 1)')}; */
    position: absolute;
    z-index: 888;
    left: 50%;
    transform: translate(-50%, 0);
    top: -10px;

    &::after {
      content: '';
      width: 0;
      height: 0;
      border-color: transparent;
      border-bottom-color: #16191e;
      border-style: dashed dashed solid dashed;
      position: absolute;
      top: -8px;
      left: -10px;
      font-size: 0;
      overflow: hidden;
      display: block;
      border-width: 10px;
    }
  }
  &.right {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid;
    border-left-color: #2e363b;
    position: absolute;
    z-index: 888;
    right: -10px;
    top: 10px;

    &::after {
      content: '';
      width: 0;
      height: 0;
      border-color: transparent;
      border-left-color: #16191e;
      border-style: dashed dashed dashed solid;
      position: absolute;
      top: -10px;
      right: -9px;
      font-size: 0;
      overflow: hidden;
      display: block;
      border-width: 10px;
    }
  }
  &.left {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid;
    border-right-color: #2e363b;
    position: absolute;
    z-index: 888;
    left: -10px;
    top: 10px;

    &::after {
      content: '';
      width: 0;
      height: 0;
      border-color: transparent;
      border-right-color: #16191e;
      border-style: dashed solid dashed dashed;
      position: absolute;
      top: -10px;
      left: -9px;
      font-size: 0;
      overflow: hidden;
      display: block;
      border-width: 10px;
    }
  }
`

export const Popover = styled('div')`
  position: absolute;
  z-index: 120;
`

export const StartTuorialBtn = styled(Button)`
  color: ${({ theme }) => theme.palette.primary.main};
  background-color: ${() =>
    themeValue('rgba(255, 255, 255, 0.1)', ' rgba(160, 160, 160, 0.10)')};
  border-radius: 2px;
  font-size: 14px;
  &:hover {
    background-color: ${() =>
      themeValue('rgba(255, 255, 255, 0.1)', ' rgba(160, 160, 160, 0.10)')};
    opacity: 0.9;
  }
  margin-left: 5px;
`

export const NoThanksButton = styled(Button)`
  color: ${() =>
    themeValue('rgba(164, 164, 164, 1)', 'rgba(145, 151, 176, 1)')};
  font-weight: normal;
  font-size: 14px;
  &:hover {
    background-color: transparent;
    opacity: 0.9;
  }
`

export const TuorialBox = styled(FlexColumn)`
  padding: 16px;
  border: 1px solid;
  border-color: ${() =>
    themeValue('rgba(75, 82, 90, 1)', 'rgba(227, 229, 235, 1)')};
  border-radius: 4px;
  background-color: ${() =>
    themeValue('rgba(30, 35, 41,1)', 'rgba(255, 255, 255, 1)')};
  width: 340px;
`

export const TuorialBoxTitle = styled('span')`
  color: ${() => themeValue('rgba(230, 230, 230,1)', 'rgba(51, 55, 67, 1)')};
  font-size: 14px;
  line-height: 20px;
`

export const TuorialBoxHelpText = styled('span')`
  font-size: 12px;
  padding: 6px;
  margin-top: 18px;
  color: ${() => themeValue('#d5d5d5', 'rgba(90, 102, 137, 1)')};
  text-align: center;
  border: 1px dashed;
  border-color: ${() =>
    themeValue('rgba(48, 48, 48, 1)', 'rgba(227, 229, 235, 1)')};
`

export const TuorialBoxFooter = styled(FlexBetween)`
  margin-top: 24px;
  align-items: center;
  font-size: 14px;
  text-align: center;
  button {
    flex: 1;
  }
`

export const StepFooter = styled(FlexBetween)`
  margin-top: 24px;
  button {
    flex: 1;
  }
`

export const StepNextButton = styled(Button)`
  margin-left: 5px;
  border-radius: 2px;
  font-size: 16px;
  height: 34px;
  background-color: #2a3139;
  color: rgba(255, 255, 255, 1);
  /* background-color: ${() =>
    themeValue('rgba(255, 255, 255, 0.05)', 'rgba(128, 128, 128, 0.05)')};
  color: ${() =>
    themeValue('rgba(164, 164, 164, 0.2)', 'rgba(86, 86, 86, 0.28)')}; */
  display: flex;
  align-items: center;
  border-radius: 30px;

  svg {
    margin-left: 5px;
  }

  &:hover {
    opacity: 0.9;
    background-color: #2a3139;
    color: rgba(255, 255, 255, 1);
  }

  &.finished {
    color: ${({ theme }) => theme.palette.primary.main};
    background-color: #2a3139;
    &:hover {
      opacity: 0.9;
    }
  }
`

export const Close = styled(SvgClose)`
  color: ${(props) => props.theme.color?.text60};
  cursor: pointer;
`

export const StepOneBox = styled(TuorialBox)`
  background-color: #16191e;
  font-family: 'Source Sans Pro';
`

export const StepHeader = styled(Flex)`
  justify-content: space-between;
`

export const StepTitle = styled('span')`
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
`

export const StepIntro = styled('div')`
  display: flex;
  align-items: center;
  span {
    margin-top: -2px;
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    font-family: 'Source Sans Pro';
    color: rgba(255, 255, 255, 1);
  }
  svg {
    margin-left: 8px;
  }
`

export const StepLink = styled('a')`
  display: inline-block;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 12px;
  margin-top: 18px;
  text-decoration: underline;
  cursor: pointer;
`

export const StepDesc = styled('span')`
  font-size: 14px;
  color: ${(props) => props.theme.color?.text80};
  margin-top: 18px;
  line-height: 20px;
`

export const StepColumnList = styled(FlexColumn)`
  margin-top: 18px;
`
export const Warning = styled(Flex)`
  color: rgba(255, 183, 0, 1);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  margin-top: 16px;
  span {
    display: inline-block;
    margin-left: 8px;
  }
`

export const ActiveStepOne = styled(Flex)`
  /* flex-direction: column; */
  display: flex;
  margin-top: 26px;
  .tag {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: rgba(160, 238, 9, 1);
    color: rgba(22, 25, 30, 1);
    font-weight: 700;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 99;

    &.line::after {
      content: '';
      width: 2px;
      z-index: 98;
      background-color: rgba(160, 238, 9, 1);
      height: 170px;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 170px);
    }
  }

  .box-left {
    margin-left: 8px;
    display: flex;
    flex-direction: column;
    width: calc(100% - 28px);
  }
`

export const ActiveStepTitle = styled('span')`
  color: #a0ee09;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
`
export const ActiveStepDesc = styled('span')`
  color: rgba(202, 213, 220, 1);
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  margin-top: 4px;
`

export const DepositeFrom = styled('div')`
  display: flex;
  align-items: center;
  margin-top: 10px;

  span {
    font-size: 11px;
    /* transform: scale(0.8); */
  }
  svg {
    margin-left: 5px;
  }
`

export const ActiveItemBox = styled('div')`
  background-color: #2a3139;
  border-radius: 3.5px;
  /* width: 260px; */
  width: 100%;
  padding: 7px 0px 7px 7px;
  box-sizing: border-box;
  /* height: 36px; */
  display: flex;
  align-items: flex-start;
  margin-top: 8px;

  .right {
    display: flex;
    flex-direction: column;
    margin-left: 2px;

    .title {
      color: #fff;
      font-size: 8px;
      font-style: normal;
      font-weight: 600;
    }

    .desc {
      display: inline-block;
      margin-top: 2px;
      color: #95a4ad;
      font-size: 7px;
      font-style: normal;
      font-weight: 400;
    }
  }
`

export const ActiveAccountItemBox = styled('div')`
  background-color: #2a3139;
  border-radius: 3.5px;
  /* width: 260px; */
  width: 100%;
  padding: 17px 12px;
  box-sizing: border-box;
  /* height: 36px; */
  display: flex;
  align-items: center;
  margin-top: 8px;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;
    svg {
      margin-right: 4px;
    }

    .content {
      display: flex;
      flex-direction: column;

      .title {
        color: #fff;
        font-size: 8px;
        font-style: normal;
        font-weight: 600;
      }

      .desc {
        display: inline-block;
        margin-top: 2px;
        color: #95a4ad;
        font-size: 7px;
        font-style: normal;
        font-weight: 400;
      }
    }
  }
`

export const ActiveButton = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #a0ee09;
  border-radius: 20px;
  padding: 8px;
  width: 60px;
  height: 20px;
  svg {
    margin-right: 4px;
  }
  span {
    color: #16191e;
    font-family: 'Source Sans Pro';
    font-size: 8px;
    font-style: normal;
    font-weight: 600;
    box-sizing: border-box;
  }
`
